import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { GoogleTagManagerService } from 'src/app/angular-google-tag-manager.service';
import { AuthHelperService } from 'src/app/auth-helper.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-content-banner',
  templateUrl: './content-banner.component.html',
  styleUrls: ['./content-banner.component.scss']
})
export class ContentBannerComponent implements OnInit {

  @Input() promo: Record<string, any>;

  treatedMobileTitle: SafeHtml = "";
  pureMobileTitle: string = "";
  treatedTitle: SafeHtml = "";
  treatedReviewText: SafeHtml = "";
  treatedButtonText: SafeHtml = "";
  treatedChecklist: Array<SafeHtml> = [];

  constructor(
    private authHelper: AuthHelperService,
    private gtmService: GoogleTagManagerService,
    private sanitiser: DomSanitizer,
  ) { }

  ngOnInit(): void {
    if (this.promo) {

      this.treatedMobileTitle = this.sanitiser.bypassSecurityTrustHtml(this.promo.mobile_title);
      this.pureMobileTitle = this.promo.mobile_title.replace( /(<([^>]+)>)/ig, '').replace("&nbsp;", "");
      this.treatedTitle = this.sanitiser.bypassSecurityTrustHtml(this.promo.title);
      this.treatedReviewText = this.sanitiser.bypassSecurityTrustHtml(this.promo.review_text);
      this.treatedButtonText = this.sanitiser.bypassSecurityTrustHtml(this.promo.btn_text);
      this.treatedChecklist = this.promo.checklists?.map(l => this.sanitiser.bypassSecurityTrustHtml(l.text));
    }
  }

  redirectBookiePromo(url, type, promo) {
    if (type === 'promo') {
      url = url.includes('src=')
        ? url.replace(`src=`, `src=${'content_banner'}`)
        : `${url}${url.includes("?") ? "&" : "?"}src=content_banner`
      const redirectLink = `${(environment.auth0Domain && this.authHelper.user) ? `&${this.authHelper.user.id}` : ''}`

      url = url.includes('c=')
        ? url.replace(`c=`, `c=${redirectLink}`)
        : `${url}${url.includes("?") ? "&" : "?"}c=${redirectLink}`

      // if (get(promo, 'state_affiliate_link.url')) {
      //   const self = this
      //   gtag('event', 'exit', {
      //     event_category: 'content_banner',
      //     event_label: promo.banner_name,
      //     event_callback(id) {
      //       if (id === self.gtmId) {
      //         window.open(`${url}`)
      //       }
      //     },
      //   })
      // } else {
      //   window.open(`${url}`)
      // }

      if (promo.state_affiliate_link?.url) {

        if (typeof window !== "undefined") {
          const gtmTag = {
            event: "exit",
            event_category: "content_banner",
            event_label: promo.bookmaker_code,
          };
      
          this.gtmService.pushTag(gtmTag)
            .then(() => {
              window.open(url, "_blank");
            })
            .catch(e => {
              console.error("Google Tag Manager Script failed: " + e)
              window.open(url, "_blank");
            });
        }
      } else {
        window.open(`${url}`)
      }
    } else {
      window.open(`${url}`)
    }
  }

}
